// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient-module__BreadBottom__3O51X","BreadTop":"BurgerIngredient-module__BreadTop__3fs0B","Seeds1":"BurgerIngredient-module__Seeds1__2yaYt","Seeds2":"BurgerIngredient-module__Seeds2__1v7H4","Meat":"BurgerIngredient-module__Meat__2zDQJ","Cheese":"BurgerIngredient-module__Cheese__3i7Jq","Salad":"BurgerIngredient-module__Salad__7E3K2","Bacon":"BurgerIngredient-module__Bacon__2yFHy","Paneer":"BurgerIngredient-module__Paneer__2s_rF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredient/BurgerIngredient.module.css
// module id = 105
// module chunks = 2